import { IntegrationVendor } from './enums/integrationEnums';

export enum IncidentSeverity {
  Info = 'Info',
  Degraded = 'Degraded',
  Critical = 'Critical',
}

export enum AffectedComponent {
  Mezzo = 'Mezzo',
  Vendor = 'Vendor',
  Other = 'Other',
}

export enum DayStatus {
  Operational = 'Operational',
  Degraded = 'Degraded',
  Down = 'Down',
}

export interface StatusIncident {
  statusIncidentId: number;
  title: string;
  detail?: string;
  startDate: Date;
  endDate?: Date;
  severity: IncidentSeverity;
  affectedComponent: AffectedComponent;
  affectedVendor?: IntegrationVendor;
  createdDate: Date;
  createdBy: string;
  updatedDate?: Date;
  updatedBy?: string;
}

export interface CreateOrUpdateStatusIncident {
  title: string;
  detail?: string;
  startDate: Date;
  endDate?: Date;
  severity: IncidentSeverity;
  affectedComponent: AffectedComponent;
  affectedVendor?: IntegrationVendor;
}

export interface DailyStatus {
  date: Date;
  status: DayStatus;
}

export interface UptimeResponse {
  uptime7Days: number;
  uptime14Days: number;
  uptime30Days: number;
  uptime60Days: number;
  uptime90Days: number;
  dailyStatuses: DailyStatus[];
}

// Vendor to IntegrationType mapping for status page categories
export const vendorCategoryMap: Record<string, string> = {
  Factual: 'Credit',
  Xactus: 'Credit',
  InformativeResearch: 'Credit',
  MeridianLink: 'Credit',
  FreddieMac: 'Underwriting',
  FannieMae: 'Underwriting',
  RatesBoard: 'Pricing',
  Flueid: 'Property Data',
  Vesta: 'LOS',
  Resend: 'Email',
  Snap: 'Flood',
  Truv: 'Income/Employment/Assets',
  Equifax: 'Income/Employment',
  Truework: 'Income/Employment',
  Argyle: 'Income/Employment/Assets',
  Ernst: 'Fees',
  SmartFees: 'Fees',
  Experian: 'Income/Employment',
};
